import { useRouter } from "vue-router";
export default function useIndexMeetingPage() {
  const router = useRouter();
  const toMeetingDetail = (item) => {
    // 图片直播跳转
    if (item.type === "IMAGES") {
      // router.push({
      //   path: "/pic-live",
      //   query: {
      //     id: item.id,
      //   },
      // });
      const { href } = router.resolve({
        path: "/pic-live",
        query: {
          id: item.id,
        },
      });
      window.open(href, "_blank");
      return;
    }
    const { href } = router.resolve({
      path: "/live/detail",
      query: {
        id: item.id,
      },
    });
    window.open(href, "_blank");
    // router.push({
    //   path: "/live/detail",
    //   query: {
    //     id: item.id,
    //   },
    // });
  };
  return {
    toMeetingDetail,
  };
}
